import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import { MonitorValues } from "monitor";
import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";

const $signageAdapter: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_SIGNAGE_ADAPTER_API_BASE_URL,
    timeout: 10000,
});

export const fetchPlaceListByPlaceIdHashList = async (
    placeIdHashList: string[],
): Promise<SignageAdapterApi.ResponseGetPlace[]> => {
    return await $signageAdapter
        .get(`/places/${placeIdHashList}`)
        .then((response: AxiosResponse) => response.data)
        .catch((error: Error) => Promise.reject(error));
};

export const fetchDisplayVacancyByPlaceIdHashList = async (
    placeIdHashList: string[],
): Promise<SignageAdapterApi.ResponseGetDisplayVacancy[]> => {
    return await $signageAdapter
        .get(`/places/${placeIdHashList}/vacancy?${Date.now()}`)
        .then((response: AxiosResponse) => response.data)
        .catch((error: Error) => Promise.reject(error));
};

export const fetchAreaGenderByPlaceIdHashList = async (
    placeIdHashList: string[],
): Promise<SignageAdapterApi.ResponseGetDisplayVacancy[]> => {
    return await $signageAdapter
        .get(`/places/${placeIdHashList}/gender`)
        .then((response: AxiosResponse) => response.data)
        .catch((error: Error) => Promise.reject(error));
};

/**
 *
 * @param monitorValues
 * monitor value
 */
export const postMonitorHealth = async (monitorValues: MonitorValues): Promise<void> => {
    return await $signageAdapter
        .post(`/signage/health`, JSON.stringify(monitorValues))
        .then((response: AxiosResponse) => response.data)
        .catch((error: Error) => Promise.reject(error));
};
